import { AddressChoiceModel } from '../../models/item_js_env';

export class DeliveryCountdown {
  static updateElement(model: AddressChoiceModel) {
    // 更新するelement
    const element = document.getElementById('js-deliverydate-countdown');
    // 更新するhelpIcon
    const helpIcon = document.getElementById('js-deliverydate-helpIcon');
    if (!element) return;

    // 基準日時 システム日時に1秒足した値を基準日時とするため、dateにしたあとに1秒足している
    const referenceDate: Date = new Date(model.systemDateTime)
    referenceDate.setSeconds(referenceDate.getSeconds() + 1)
    // 受注締め日時
    const orderClosingDateTime: Date = new Date(model.orderClosingDateTime);
    // 希望数量element
    const hopeQuantityElement = document.getElementById('hopeQuantity') as HTMLInputElement;
    // 希望数量
    const hopeQuantity = hopeQuantityElement ? hopeQuantityElement.value : '0';
    // 在庫数element
    const stockCountElement = document.getElementById('stockCount') as HTMLInputElement;
    // 在庫数
    const stockCount = stockCountElement ? stockCountElement.value : '0';
    // お届け日の「最短」表示有無判定
    const shouldDisplayShortestDeliveryDate = element.classList.contains('js-should-display-shortest-delivery-date');
    // お急ぎ便併記表示対象判定
    const shouldDisplayExpressDeliveryDate = element.classList.contains('js-express-delivery-date-countdown');
    // お届け日表示文言
    const deliveryDateWording = this.getDeliveryDateWording(
      model,
      shouldDisplayShortestDeliveryDate,
    );
    // loadイベント時に開始
    window.addEventListener('load', function(){
      // 在庫表示エリアの文言更新
      const timer = setInterval(
        () => {
          if (element == null) {
            clearInterval(timer);
            return;
          };

          // 基準日時に1秒足す
          referenceDate.setSeconds(referenceDate.getSeconds() + 1)

          // 秒数が0でない場合は分が更新されなく、以降処理する必要がないのでreturnする
          // ただし初回は更新する必要があるのでinnerHTMLが空の場合はreturnさせない
          if (referenceDate.getSeconds() != 0 && element.innerHTML != "") {
            return;
          }

          if (referenceDate.getTime() < orderClosingDateTime.getTime()) {
            // 基準日時が受注締め日時以前の場合のみ、残り時間文字列に差し替える
            const timeDiff = Math.ceil((orderClosingDateTime.getTime() - referenceDate.getTime()) / (1000 * 60));
            const hours = Math.floor(timeDiff / 60);
            const minutes = timeDiff - (hours * 60);
            if (shouldDisplayExpressDeliveryDate) {
              element.innerHTML = DeliveryCountdown.getDeliveryDateElementForExpress(hours, minutes, hopeQuantity, stockCount, deliveryDateWording);
            } else {
              element.innerHTML = DeliveryCountdown.getDeliveryDateElement(hours, minutes, hopeQuantity, stockCount, deliveryDateWording);
            }
            // カウントダウン処理で「お届け日：～」表示パタンで、画面は最終的には「お届け日：～　？マーク」と表示されるが、
            // カウントダウン描画処理が遅延する場合に？マークだけ先に表示される場合があり、
            // その後に「お届け日：～　？マーク」と表示されることがあるため、以下処理を追加対応する
            if (helpIcon != null) {
              helpIcon.style.display = 'inline'
            }
          } else {
            clearInterval(timer)
            if (!shouldDisplayExpressDeliveryDate) {
              element.innerHTML = `<a href="javascript:location.reload();" id="js-get-new-deliverydate">最新のお届け日を表示</a>`;
            }
            if (helpIcon != null) {
              helpIcon.style.display = 'none'
            }
          };
        },
        1000
      )
    })
  }

  private static getDeliveryDateWording(
    model: AddressChoiceModel,
    shouldDisplayShortestDeliveryDate: boolean,
  ): string {
    const prefix = shouldDisplayShortestDeliveryDate ? '最短 ' : '';
    const deliveryDateWording = model.sameDayDeliveryDateWording || model.nextDayDeliveryDateWording;
    return `${prefix}${deliveryDateWording}`;
  }

  private static getDeliveryDateElement(
    hours: number,
    minutes: number,
    hopeQuantity: string,
    stockCount: string,
    deliveryDateWording: string,
  ): string {
    if (hours === 0) {
      if (Number(hopeQuantity) <= Number(stockCount)) {
        return `お届け日：今から<b>` +
          `${minutes.toString()}分以内</b>のご注文で、<b>` +
          `${deliveryDateWording}</b>にお届け`;
      } else {
        return `お届け日：<span class="a-span u-text-red">数量${stockCount}点以下に限り</span>、` +
          `今から<b>${minutes.toString()}分以内</b>のご注文で、`+
          `<b>${deliveryDateWording}</b>にお届け`;
      }
    } else {
      if (Number(hopeQuantity) <= Number(stockCount)) {
        return `お届け日：今から<b>` +
          `${hours.toString()}時間${minutes.toString()}分以内</b>のご注文で、<b>` +
          `${deliveryDateWording}</b>にお届け`;
      } else {
        return `お届け日：<span class="a-span u-text-red">数量${stockCount}点以下に限り</span>、` +
          `今から<b>${hours.toString()}時間${minutes.toString()}分以内</b>のご注文で、`+
          `<b>${deliveryDateWording}</b>にお届け`;
      }
    }
  }

  private static getDeliveryDateElementForExpress(
    hours: number,
    minutes: number,
    hopeQuantity: string,
    stockCount: string,
    deliveryDateWording: string,
  ): string {
    if (hours === 0) {
      if (Number(hopeQuantity) <= Number(stockCount)) {
        return `お急ぎ便：${deliveryDateWording}にお届け（今から${minutes.toString()}分以内のご注文で指定可。追加料金なし）`;
      } else {
        return `お急ぎ便：<span class="a-span u-text-red">数量${stockCount}点以下に限り</span>、` +
          `${deliveryDateWording}にお届け（今から${minutes.toString()}分以内のご注文で指定可。追加料金なし）`;
      }
    } else {
      if (Number(hopeQuantity) <= Number(stockCount)) {
        return `お急ぎ便：${deliveryDateWording}にお届け（今から${hours.toString()}時間${minutes.toString()}分以内のご注文で指定可。追加料金なし）`;
      } else {
        return `お急ぎ便：<span class="a-span u-text-red">数量${stockCount}点以下に限り</span>、` +
          `${deliveryDateWording}にお届け（今から${hours.toString()}時間${minutes.toString()}分以内のご注文で指定可。追加料金なし）`;
      }
    }
  }
}
